// Common
import { ReactElement } from 'react'

// Styles
import { makeStyles } from '@material-ui/styles'

// Components
import Row from 'shared-components/row'
import { Button } from '@material-ui/core'

// Hooks
import useMobile from 'components/hooks/useMobile'

// Interface
import { IPropsButtons } from '../interface'

const useStyle = makeStyles({
	next: {
		textAlign: 'center',
		backgroundColor: '#73C21E',
		border: '1px solid #73C21E',
		color: '#fff',
		transition: 'none',
		width: '90px',
		textTransform: 'none',
		fontWeight: 600,
		'&:hover': {
			color: '#fff',
			border: '1px solid #8A54E8',
			backgroundColor: '#8A54E8',
		},
	},
	back: {
		textAlign: 'center',
		backgroundColor: 'transparent',
		border: '1px solid #C4C4C4',
		color: '#C4C4C4',
		marginRight: '20px',
		width: '90px',
		transition: 'none',
		textTransform: 'none',
		fontWeight: 400,
		'&:hover': {
			color: '#fff',
			border: '1px solid #8A54E8',
			backgroundColor: '#8A54E8',
		},
	},
})

export default function Buttons(props: IPropsButtons): ReactElement {
	const classes = useStyle()
	const mobile = useMobile()
	const { goBack, goNext, disable } = props
	return (
		<Row style={ mobile ? {marginTop: '20px', alignItems: 'center'} : {marginTop: '50px', alignItems: 'center'}}>
			<Button
				disableRipple
				disableFocusRipple
				onClick={goBack}
				className={classes.back}
			>
				Back
			</Button>
			<Button
				disableRipple
				disableFocusRipple
				onClick={goNext}
				className={classes.next}
				disabled={disable}
				style={{ backgroundColor: '#73C21E', borderColor: '#73C21E' }}
			>
				Next
			</Button>
		</Row>
	)
}
